import "./NotFound.scss";

import { FC } from "react";
import { useNavigate } from "react-router-dom";

import Button from "components/Button/Button";
import Icon from "components/Icon/Icon";
import Text from "components/Text/Text";
import Container from "containers/Container/Container";
import { useTranslation } from "modules";
import { useScreenTestId } from "modules/hooks/useScreenTestId";

const NotFound: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const screenTestId = useScreenTestId();

  return (
    <Container className="not-found__container" data-testid={screenTestId}>
      <div className="not-found__wrapper">
        <Icon size="xl" src="BlobAlert" />
        <Text
          className="not-found__header"
          tag="h4"
          text={t("blocked.system_error.title", "Oops! We must've moved whatever was here")}
        />
        <Text
          className="not-found__subheader"
          tag="p3"
          text={t(
            "blocked.system_error.body",
            "Let's get you back on track and pretend this never happened."
          )}
        />

        <Button
          className="not-found__cta"
          onClick={() => navigate("/")}
          text={t("blocked.system_error.button", "FORGET YOU SAW THIS")}
        />
      </div>
    </Container>
  );
};

export default NotFound;
